/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gradelevel_Q42Inputs */

const en__field__enum_gradelevel_q42 = /** @type {(inputs: _Field__Enum_Gradelevel_Q42Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q4`)
};

const de__field__enum_gradelevel_q42 = /** @type {(inputs: _Field__Enum_Gradelevel_Q42Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q4`)
};

/**
* | output |
* | --- |
* | "Q4" |
*
* @param {_Field__Enum_Gradelevel_Q42Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gradelevel_q42 = /** @type {((inputs?: _Field__Enum_Gradelevel_Q42Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gradelevel_Q42Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gradelevel_q42(inputs)
	return de__field__enum_gradelevel_q42(inputs)
});
export { _field__enum_gradelevel_q42 as "_field__enum_gradeLevel_Q4" }